<template>
	<div id="service5">
		<Menu areWeinServices="true" selectedRoute="guard"/>
		<div class="colorAzul">
			<section class="secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
				<div class="fondotransparenteServicio">
					<h1>{{title}}</h1>
				</div>
			</section>

			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">We can help you plan and deploy new guard services, monitor the performance of your guard service provider, and help you improve coverage of your service</h2>

						<p class="parrafoContenidoInterno">
							Our specialized service is designed for management of security guards in corporate HQs, malls, department stores, companies and industrial plants.
							<br>
							<br>We have a Monitoring and Analysis Center with supervisors and can quickly react to unexpected circumstances such as:
							<br>
						</p>
						<ul class="listaContenidoInterno">
							<li>Guards due to absence</li>
							<li>Weekend guards</li>
							<li>Guards for clearance sales</li>
							<li>Guards for receiving goods and merchandise</li>
						</ul>
						<p class="parrafoContenidoInterno">
							Our monitoring center takes care of verifying hours, attendance, instructions and presence of the guards in real time.
							<br>
							<br>

							<span>Grupo Glarus</span> conducts studies and detailed assessments to find the best Operation Supervisors for your Guard Service, depending on your needs and requirements.
						</p>
					</div>

					<cuadro/>
				</div>
			</section>

			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>{{titleIcons}}</span>
					</h1>

					<div class="gridIcons" :class="{spaceBetWeen: precautions.length >2}">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/2_seguridad.jpg";
import imagen2 from "@/assets/img/servicios/5/second_.jpg";
import icono01 from "@/assets/img/servicios/5/01.png";
import icono02 from "@/assets/img/servicios/5/02.png";
import icono03 from "@/assets/img/servicios/5/03.png";

export default {
	name: "servicio05",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title = "Services / Coverage and monitoring for guards / Glarus";
		});
	},
	data: function() {
		return {
			title: "GUARD SERVICE IMPLEMENTATION AND MONITORING",
			// subtitle: "Coverage and monitoring for guards",
			// thirdTitle: "Management and supervision of security human capital.",
			firstImage: imagen1,
			secondImage: imagen2,
			titleIcons: "We Provide",

			precautions: [
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 5",
					descripcion: "Monitoring Center 24x7x365"
				},
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 5",
					descripcion: "Operation Supervisors"
				},
				{
					id: "3",
					icon: icono03,
					altIcon: "glarus service 5",
					descripcion: "Trained Guards"
				}
			]
		};
	}
};
</script>




<style lang="less">
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
